import { render, staticRenderFns } from "./GrilletarifairesNews.vue?vue&type=template&id=09a7f25c&"
import script from "./GrilletarifairesNews.vue?vue&type=script&lang=js&"
export * from "./GrilletarifairesNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports